import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { delay, map } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';
import { of, throwError } from 'rxjs';


@Injectable()
export class CreditosService {

  token: string;
  idUsuario: string;
  path: string =  environment.URL_SERVICIOS.replace('/api/v1','');

  constructor(
    public http: HttpClient,
    public router: Router
  ) {
    this.cargarStorage();
  }

  cargarStorage() {

    if ( localStorage.getItem('tkn')) {
      this.token = localStorage.getItem('tkn');
    } else {
      this.token = '';
    }

  }

// CONDICIONES
  crearCondicion( params ) {
    params.secret_key = environment.SECRET_KEY;
    const url = `${ environment.URL_SERVICIOS }/terms?token='${this.token}'`; //  ?option[name]=${ name }&option[description]=${ desc }&option[group]=${ group }&option[url]=${ urlo }&token=1&secret_key=${ environment.SECRET_KEY };

    return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return resp;
              }));
  }

  getCondiciones() {

    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
    const url = `${ environment.URL_SERVICIOS }/terms?`;

    return this.http.get( url, { params } ).pipe(
    map( (resp: any) => {return this.crearArregloterms(resp);
    }));

  }

  getCondiciones2() {
    const url = `${this.path}/terms?`;
    return this.http.get(url).pipe(
    map( (resp: any) => {return resp['terms'];
    }));

  }

  crearArregloterms( optionsObj: any) {

    const options: any[] = [];
    const resul: any[] = [];

    if ( optionsObj === null ) { return []; }
    Object.keys ( optionsObj ).forEach( key => {
      const rol: any = optionsObj[key];
      options.push( rol );
    });
    // tslint:disable-next-line: forin
    for (const prop in options[0]) {
  //  console.log( usuarios[0][prop].attributes );
    resul.push( options[0][prop].attributes );
    }

   // console.log(resul);

    return resul;

}

getCondicion( id: string ) {

  const url = `${environment.URL_SERVICIOS}/terms/${id}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get( url ).pipe(
    map ( (resp: any) => { return this.crearArregloExtService(resp);
    } ));

}

crearArregloExtService( optionObj: any) {

  const option: any[] = [];
  const resul: any[] = [];
 // console.log(usuariosObj);
  if ( optionObj === null ) { return []; }
  Object.keys ( optionObj ).forEach( key => {
    const r: any = optionObj[key];
    option.push( r );
  });
  // tslint:disable-next-line: forin
//  console.log( usuarios[0][prop].attributes );
  resul.push( optionObj.data.attributes );

  return resul;

}

actualizaCondicion(ido: string, params) {
  params.secret_key = environment.SECRET_KEY;
  
 // console.log(params);
const url = `${environment.URL_SERVICIOS}/terms/${ido}?token=${this.token}`;

return this.http.patch( url, params ).pipe(
  map( (resp: any) => { return resp;
  } ));
}

borrarCondicion(id: string) {

  const params = {
    token: this.token,
    secret_key: environment.SECRET_KEY
  }

  const url = `${ environment.URL_SERVICIOS }/terms/${ id }?`;

  return this.http.delete( url, {params} ).pipe(
    map( (resp: any) => { return resp;
     } ));

}

// PERIODOS DE PAGO

getperiodosPagos() {

  const params = {
    token: this.token,
    secret_key: environment.SECRET_KEY
  }
  const url = `${ environment.URL_SERVICIOS }/payment_periods?`;

  return this.http.get( url, { params } ).pipe(
  map( (resp: any) => {return this.crearArregloPeriodosPagos(resp);
  }));

  }

  getperiodosPagos2() {

    const url = `${ this.path }/payment_periods?`;
  
    return this.http.get( url ).pipe(

    map( (resp: any) => { return resp;
    }));
  
    }

crearArregloPeriodosPagos( optionsObj: any) {
  const options: any[] = [];
  const resul: any[] = [];

  if ( optionsObj === null ) { return []; }
  Object.keys ( optionsObj ).forEach( key => {
    const rol: any = optionsObj[key];
    options.push( rol );
  });
  // tslint:disable-next-line: forin
  for (const prop in options[0]) {
//  console.log( usuarios[0][prop].attributes );
  resul.push( options[0][prop] );
  }

  return resul;

}

borrarPeriodoPago(id: string) {

  const params = {
    token: this.token,
    secret_key: environment.SECRET_KEY
  }

  const url = `${ environment.URL_SERVICIOS }/payment_periods/${ id }?`;

  return this.http.delete( url, {params} ).pipe(
    map( (resp: any) => { return resp;
     } ));

}

getPeriodoPago( id: string ) {

  const url = `${environment.URL_SERVICIOS}/payment_periods/${id}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get( url ).pipe(
    map ( (resp: any) => { return this.crearArregloExtService(resp);
    } ));

}

actualizaPeriodoPago(ido: string, params) {
  params.secret_key = environment.SECRET_KEY;
  params.token = this.token;
const url = `${environment.URL_SERVICIOS}/payment_periods/${ido}?`;

return this.http.patch( url, params ).pipe(
  map( (resp: any) => { return resp;
  } ));
}

crearPeriodoPago( params ) {
  params.secret_key = environment.SECRET_KEY;
  params.token = this.token;
  const url = `${ environment.URL_SERVICIOS }/payment_periods?`;

  return this.http.post( url, params ).pipe(
            map( (resp: any) => {
              return resp;
            }));
}

// CALIFICACION CREDITOS

getCalificacionCreditos() {

  const params = {
    token: this.token,
    secret_key: environment.SECRET_KEY
  }
  const url = `${ environment.URL_SERVICIOS }/credit_ratings?`;

  return this.http.get( url, { params } ).pipe(
  map( (resp: any) => {return this.crearArregloPeriodosPagos(resp);
  }));

  }

  crearCalificacionCreditos( params ) {
    params.secret_key = environment.SECRET_KEY;
    params.token = this.token;
    const url = `${ environment.URL_SERVICIOS }/credit_ratings?`; 
  
    return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return resp;
              }));
  }

  borrarCalificacionCredito(id: string) {

    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
  
    const url = `${ environment.URL_SERVICIOS }/credit_ratings/${ id }?`;
  
    return this.http.delete( url, {params} ).pipe(
      map( (resp: any) => { return resp;
       } ));
  
  }

  getCalificacionCredito( id: string ) {

    const url = `${environment.URL_SERVICIOS}/credit_ratings/${id}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  
    return this.http.get( url ).pipe(
      map ( (resp: any) => { return this.crearArregloExtService(resp);
      } ));
  
  }

  actualizaCalificacionCredito(ido: string, params) {
    params.secret_key = environment.SECRET_KEY;
    params.token = this.token;
  const url = `${environment.URL_SERVICIOS}/credit_ratings/${ido}?`;
  
  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));
  }

  // RATES

getRates() {

  const params = {
    token: this.token,
    secret_key: environment.SECRET_KEY
  }
  const url = `${ environment.URL_SERVICIOS }/rates?`;

  return this.http.get( url, { params } ).pipe(
  map( (resp: any) => {return this.crearArregloPeriodosPagos(resp);
  }));

  }

  crearRate( params ) {
    params.secret_key = environment.SECRET_KEY;
    params.token = this.token;
    const url = `${ environment.URL_SERVICIOS }/rates?`; 
  
    return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return resp;
              }));
  }

  borrarRate(id: string) {

    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
  
    const url = `${ environment.URL_SERVICIOS }/rates/${ id }?`;
  
    return this.http.delete( url, {params} ).pipe(
      map( (resp: any) => { return resp;
       } ));
  
  }

  getRate( id: string ) {

    const url = `${environment.URL_SERVICIOS}/rates/${id}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  
    return this.http.get( url ).pipe(
      map ( (resp: any) => { return this.crearArregloExtService(resp);
      } ));
  
  }

  actualizaRate(ido: string, params) {
    params.secret_key = environment.SECRET_KEY;
    params.token = this.token;
  const url = `${environment.URL_SERVICIOS}/rates/${ido}?`;
  
  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));
  }


  // PROJECT REQUEST
  crearRequestProject( params ) {
    params.secret_key = environment.SECRET_KEY;
    params.token = this.token;
    const url = `${ environment.URL_SERVICIOS }/project_requests?`; 
  
    return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return resp;
              }));
  }
  
  simCredit( info ) {
    let params = {
      secret_key : environment.SECRET_KEY,
      token : this.token,
      sim_credit : info
    }
    const url = `${ environment.URL_SERVICIOS }/sim_credit?`; 
    console.log(url, params);
    return this.http.post( url, {params} ).pipe(
              map( (resp: any) => {
                return resp;
              }));
  }

  getProjectRequests(){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
    const url = `${environment.URL_SERVICIOS}/project_requests`;
    
    return this.http.get(url, {params})
  }

  getProjectCustomerReport(projectId){
    const params = {
      project_request_id: projectId,
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
    const url = `${ environment.URL_SERVICIOS }/get_project_request_customer_report?`;
  
    return this.http.get( url, { params } );
  }

  updateRequest(id, update){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }

    const url = `${environment.URL_SERVICIOS}/project_requests/${id}`;
    
    return this.http.patch(url, update, {params})
  }

  createProject(rowData){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }

    const url = `${environment.URL_SERVICIOS}/projects`;
    
    return this.http.post(url, rowData, {params})
  }

  getCredits(){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
    const url = `${environment.URL_SERVICIOS}/customer_credits`;
    
    return this.http.get(url, {params})
  }

  getCredit( id ){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
    const url = `${environment.URL_SERVICIOS}/customer_credits/${id}`;
    
    return this.http.get(url, {params})
  }

  getSignatoriesByCreditId( id ){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
      id: id
    }
    const url = `${environment.URL_SERVICIOS}//customer_credits_signatory/customer_credit_id`;
    
    return this.http.get(url, {params})
  }

  updateSignatory(id, credit_id){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
      customer_credits_signatories: {
        customer_credit_id: credit_id
      }
    }

    const url = `${environment.URL_SERVICIOS}/customer_credits_signatories/${id}`;
    
    return this.http.patch(url, params)
  }

  getCredit2( id ){

    const url = `${this.path}/get_customer_credits?id=${id}`;
    
    return this.http.get(url)
  }

  customerCredit(rowData){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }

    const url = `${environment.URL_SERVICIOS}/customer_credits`;
    
    return this.http.post(url, rowData, {params})
  }
  
  customerCreditPayments(id){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
    const url = `${environment.URL_SERVICIOS}/customer_credits/${id}/sim_customer_payments`;
    
    return this.http.get(url, {params})
  }

  customerCreditPayments2(id){

    const url = `${this.path}/sim_customer_payments?id=${id}`;
    
    return this.http.get(url)
  }

  updateCredit(id, update){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }

    const url = `${environment.URL_SERVICIOS}/customer_credits/${id}`;
    
    return this.http.patch(url, update, {params})
    //return of({ message: 'ok' }).pipe(delay(9000));
  }

  updateDateCredit(update){
    update.secret_key = environment.SECRET_KEY;
    update.token = this.token;

    const url = `${environment.URL_SERVICIOS}/update_date_customer_credit?`;
    
    return this.http.patch(url, update)
    //return of({ message: 'ok' }).pipe(delay(9000));
  }

  // Ajuste de fecha de inicio a HOY para creditos GPA en estatus PA (herramienta de soporte).
  // El backend usa la fecha de hoy automaticamente; solo enviamos el id del credito y el usuario en sesion.
  adjustGpaCreditDate(customer_credit_id, user_id){
    const body = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
      customer_credit_id,
      user_id
    };

    const url = `${environment.URL_SERVICIOS}/adjust_gpa_credit_date`;

    return this.http.patch(url, body);
  }

  solicitarFirma(uuid) {
    const url = `${environment.URL_SERVICIOS}/generate_mifiel_signature_request_for_customer_credit_contract?token=${this.token}&secret_key=${environment.SECRET_KEY}&customer_credit_id=${uuid}`;
    return this.http.post(url,null)
    //return of({ message: 'firma_ok' }).pipe(delay(15000));
  }

  recoverCreditAnalysis(oldId, newId){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
      old_credit_id: oldId,
      new_credit_id: newId
    }

    const url = `${environment.URL_SERVICIOS}/update_analysis`;
    
    return this.http.patch(url, params)
  }

  updateFirmaCredit(signatory_token, status, comment = 'No comments'){

    const url = `${this.path}/customer_credit_signatory?signatory_token=${signatory_token}&status=${status}&comment=${comment}`;
    // AQUI ES POST POR QUE EL SERVICIO ASI LO PIDE
    return this.http.post(url,null)
  }

  getCustomerRegistrationReport(id){
    const secret_key = environment.SECRET_KEY;
    const token = this.token;
    const customer_url =`${environment.URL_SERVICIOS}/reports/get_customer_registration_report/?customer_credit_id=${id}&token=${token}&secret_key=${secret_key}`;
    return this.http.get(customer_url);
  }

  customer_credits_by_status(idu, status){
    const secret_key = environment.SECRET_KEY;
    const token = this.token;
    const customer_url =`${environment.URL_SERVICIOS}/reports/user_id/${idu}/user_requests_by_status?status=${status}&token=${token}&secret_key=${secret_key}`;
    return this.http.get(customer_url);
  }

  traer_customer(id){
    const secret_key = environment.SECRET_KEY;
    const token = this.token;
    const customer_url =`${environment.URL_SERVICIOS}/get_credit_customer_report?customer_credit_id=${id}&token=${token}&secret_key=${secret_key}`;
    return this.http.get(customer_url);
  }

  traer_customer2(id){
    const customer_url =`${this.path}/get_credit_customer_report?customer_credit_id=${id}`;
    return this.http.get(customer_url);
  }

  ext_rates(){
    const secret_key = environment.SECRET_KEY;
    const token = this.token;
    const url =`${environment.URL_SERVICIOS}/ext_rates?token=${token}&secret_key=${secret_key}`;
    return this.http.get(url);
  }

  ext_rates2(){
    // const secret_key = environment.SECRET_KEY;
    // const token = this.token;
    const url =`${this.path}/ext_rates`;
    return this.http.get(url);
  }

  crear_credit_analisis(
    credit_cp,  
    departamental_credit,
    credit_lp,
    car_credit,
    mortagage_loan,
    other_credits,
    debt_cp,
    departamentalc_debt,
    personalc_debt,
    car_debt,
    mortagage_debt,
    notes,
    otherc_debt,
    previus_credit,
    // discounts,
    mop,
    valorscoreBuro2,
    valorultimaClave,
    credit_id,
    valorfechaReporte: string,
    valorclaveBaja){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
    }
    // ENDPOINT QUE CREA UN CREDITALANISIS
    const url = `${environment.URL_SERVICIOS}/credit_analyses?credit_analysis[otherc_debt]=${otherc_debt}&credit_analysis[mortagage_debt]=${mortagage_debt}&credit_analysis[car_debt]=${car_debt}&credit_analysis[personalc_debt]=${personalc_debt}&credit_analysis[departamentalc_debt]=${departamentalc_debt}&credit_analysis[debt_cp]=${debt_cp}&credit_lp=${credit_lp}&credit_cp=${credit_cp}&credit_analysis[departamental_credit]=${departamental_credit}&credit_analysis[car_credit]=${car_credit}&credit_analysis[other_credits]=${other_credits}&credit_analysis[mortagage_loan]=${mortagage_loan}&credit_analysis[credit_status]=${valorscoreBuro2}&credit_analysis[previus_credit]=${previus_credit}&token=${this.token}&secret_key=${environment.SECRET_KEY}&credit_analysis[discounts]=0&credit_analysis[mop_key]=${mop}&credit_analysis[last_key]=${valorultimaClave}&credit_analysis[customer_credit_id]=${credit_id}&credit_analysis[report_date]=${valorfechaReporte}&credit_analysis[lowest_key]=${valorclaveBaja}&credit_analysis[notes]=${notes}`;
    return this.http.post(url,null)
  }

  actualizar_credit_analisis(    analisis_id,
    // total_amount,
    // accured_liabilities,
    mortagage_loan,
    other_credits,
    car_credit,
    departamental_credit,
    credit_lp,
    credit_cp,
    // balance_due,
    // net_flow,
    // debt,
    // anual_rate,
    // credit_type,
    // payment_capacity,
    // debt_rate,
    // cash_flow,
    // debt_horizon,

    debt_cp,
    departamentalc_debt,
    personalc_debt,
    car_debt,
    mortagage_debt,
    otherc_debt,
    previus_credit,
    // discounts,
    // total_cost
    // valorflujoneto,
    // valorscoreBuro2,
    // previuscredit,
    // valordescuentosexcedentreinta,
    // valorhorizonte,
    // valorultimaClave,
    // valorcreditosolicitado,
    // credit_id,
    // valorfechaReporte: string,
    // valorclaveBaja
    ){
    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
    }
    // ENDPOINT QUE GENERA AUTOMATICAMENTE UN CREDITALANISIS
    const url = `${environment.URL_SERVICIOS}/credit_analyses/${analisis_id}?credit_analysis[discounts]=""&credit_analysis[previus_credit]=${previus_credit}&credit_analysis[departamental_credit]=${departamental_credit}&credit_analysis[car_credit]=${car_credit}&credit_analysis[other_credits]=${other_credits}&credit_analysis[mortagage_loan]=${mortagage_loan}&token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.patch(url,null)
  }

  actualizaAnalisis(analisis_id, params) {
    
   // console.log(params);
  const url = `${environment.URL_SERVICIOS}/credit_analyses/${analisis_id}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  
  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));
  }
 
 tiene_analisis(customer){
  const url = `${environment.URL_SERVICIOS}/credit_analysis/has_credit_analysis?id=${customer.id_credito}&secret_key=${environment.SECRET_KEY}&token=${this.token}`;
  return this.http.post( url, null).pipe(
  map( (resp: any) => { return (resp); 
  }));
 }

 tiene_analisis2(customer){
  const url = `${this.path}/credit_analysis/has_credit_analysis?id=${customer.id_credito}`;
  return this.http.post( url, null).pipe(
  map( (resp: any) => { return (resp); 
  }));
 }

 elimina_analisis(id){
  const params = {
    token: this.token,
    secret_key: environment.SECRET_KEY
  }
  const url = `${environment.URL_SERVICIOS}/credit_analyses/${id}?`;
  return this.http.delete( url, {params}).pipe(
  map( (resp: any) => { return (resp); 
  }));
 }

 tiene_buro(customer){
  const url = `${environment.URL_SERVICIOS}/credit_bureaus/has_credit_bureau?id=${customer.id_cliente}&secret_key=${environment.SECRET_KEY}&token=${this.token}`;
  return this.http.post( url, null).pipe(
  map( (resp: any) => { return (resp); 
  }));
 }

 tiene_buro2(customer){
  const url = `${this.path}/credit_bureaus/has_credit_bureau?id=${customer.id_cliente}`;
  return this.http.post( url, null).pipe(
  map( (resp: any) => { return (resp); 
  }));
 }

 trae_buro(customer){
  const url = `${environment.URL_SERVICIOS}/credit_bureaus/traer_buro?id=${customer.id_credito}&secret_key=${environment.SECRET_KEY}&token=${this.token}`;
  return this.http.post( url, null).pipe(
  map( (resp: any) => { return (resp); 
  }));
 }

 elimina_buro(id: string){
  const params = {
    token: this.token,
    secret_key: environment.SECRET_KEY
  }
  const url = `${environment.URL_SERVICIOS}/credit_bureaus/${id}?`;
  return this.http.delete( url, {params}).pipe(
  map( (resp: any) => { return (resp); 
  }));
 }
 
  async genera_reporte_pdf_de_buro(customer){
  const url = `${environment.URL_SERVICIOS}/credit_bureau_pdf?id=${customer.id_credito}&secret_key=${environment.SECRET_KEY}&token=${this.token}`;
  return this.http.post( url, null).pipe(
  map( (resp: any) => { return (resp); 
  })
  );
 }

 limitarDecimales(event: any) {
  // para validar y limitar el número de decimales en tiempo real
  const input = event.target as HTMLInputElement;
  let value = input.value;
  // elimino caracteres no numericos excepto el punto decimal
  value = value.replace(/[^0-9.]/g, '');
  
  const parts = value.split('.');
  if (parts.length === 2) {
    parts[1] = parts[1].substring(0, 2);
    value = parts.join('.');
  }
  return value;
}

formatearFocoPerdido(event: any) {
  // Para cuando pierda el foco formatear
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  // elimino caracteres no numericos excepto el punto decimal
  value = value.replace(/[^0-9.]/g, '');
  
  // mantengo solo el primer decimal
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('');
  }
  
  // formateo y limito a solo dos decimales
  let [integerPart, decimalPart] = value.split('.');
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  decimalPart = (decimalPart || '').padEnd(2, '0').substring(0, 2);

  // actualizo visualmente
  // input.value = `${integerPart}${decimalPart ? '.' + decimalPart : ''}`;
  return `${integerPart}${decimalPart ? '.' + decimalPart : ''}`
}

getFinDetailsbycustomerCredit(id){
  const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
    const url = `${environment.URL_SERVICIOS}/fin_credit_details/by_customer_credit/${id}`;
    
    return this.http.get(url, {params})
}

}